import { getAdapters } from '../adapters/getAdapters';
import Raven from 'raven-js';
import devLogger from 'react-utils/devLogger';
export const findAdapterFromAssetFamily = assetFamily => {
  const supportedAdapter = getAdapters().find(adapter => adapter.isAssetFamilySupported(assetFamily));
  if (!supportedAdapter) {
    devLogger.warn({
      key: 'No supported adapter',
      message: `Adapter not provided for asset family: ${assetFamily}`
    });
    Raven.captureException(new Error(`Adapter not provided for asset family: ${assetFamily}`));
  }
  return supportedAdapter;
};